export { PackageDetail } from "./components/PackageDetail";
